import React, {useMemo} from "react";
import {List, ListItem, styled, Typography} from "@mui/material";
import {THEME_CONFIG} from "../../../config";
import {getTranslatedAnswers} from "../../../functions/getTranslatedAnswers";
import useLanguageStore from "../../../store/languageStore";

const {poll, pollBorder, pollTextColor, borderRadius, shadows} = THEME_CONFIG

export default function QuizQuestion({risposte, risposteTranslations, corretta, hideResult = false, answer, sendAnswer, isPoll}) {
    const { currentLanguage, defaultLanguage } = useLanguageStore();
    
    // Ottieni le risposte tradotte
    const translatedRisposte = useMemo(() => {
        return getTranslatedAnswers(risposte, risposteTranslations, currentLanguage, defaultLanguage);
    }, [risposte, risposteTranslations, currentLanguage, defaultLanguage]);

    // Trova l'indice della risposta data (answer) nelle risposte originali
    const answerIndex = useMemo(() => {
        if (!answer || answer === '') return -1;
        return risposte.findIndex(r => r === answer);
    }, [answer, risposte]);

    // Trova l'indice della risposta corretta
    const correctIndex = useMemo(() => {
        if (!corretta || corretta === '') return -1;
        return risposte.findIndex(r => r === corretta);
    }, [corretta, risposte]);

    const RispostaStyled = styled(ListItem)({
        border: `2px solid ${pollBorder.default}`,
        borderRadius: borderRadius.default,
        background: poll.default,
        margin: '1rem 0',
        cursor: 'pointer',
        color: pollTextColor.default,
        boxShadow: shadows.default,
    })

    const computeBkg = (index) => {
        if(!isPoll && hideResult === false) {
            if (answerIndex !== -1) {
                if (correctIndex === index) {
                    return poll.correct
                } else if (answerIndex === index && answerIndex !== correctIndex){
                    return poll.wrong
                }
            }
        } else {
            if(answerIndex === index) {
                return poll.answered
            }
        }

    }

    const computeBorderColor = (index) => {
        if(!isPoll && hideResult === false) {
            if (answerIndex !== -1) {
                if (correctIndex === index) {
                    return pollBorder.correct
                } else if (answerIndex === index && answerIndex !== correctIndex){
                    return pollBorder.wrong
                }
            }
        } else {
            if(answerIndex === index) {
                return pollBorder.answered
            }
        }
    }

    const computeTextColor = (index) => {
        if(!isPoll && hideResult === false) {
            if (answerIndex !== -1) {
                if (correctIndex === index) {
                    return pollTextColor.correct
                } else if (answerIndex === index && answerIndex !== correctIndex) {
                    return pollTextColor.wrong
                }
            }
        } else {
            if(answerIndex === index) {
                return pollTextColor.answered
            }
        }
    }

    const Risposte = () => (
        translatedRisposte.map((r, i) => (
            <RispostaStyled key={i} style={{
                width: '100%',
                background: computeBkg(i),
                border: computeBorderColor(i) ? '2px solid '+ computeBorderColor(i) : `2px solid ${pollBorder.default}`,
                color: computeTextColor(i) ?  computeTextColor(i) :  pollTextColor.default,
                boxShadow: shadows.default,
            }} onClick={() => rispondi(i)}>
                <Typography variant="h6" textAlign='center' width={'100%'} whiteSpace='pre-line'>
                    {r || risposte[i]}
                </Typography>
            </RispostaStyled>
        ))
    )

    const rispondi = (index) => {
        // Usa l'indice per ottenere la risposta originale nella lingua di default
        const originalAnswer = risposte[index];
        if(isPoll) {
            sendAnswer(originalAnswer)
        } else {
            if(answer === '') {
                sendAnswer(originalAnswer)
            }
        }
    }

    return (
        <List>
            <Risposte/>
        </List>
    )
}
